import { EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Dialog } from 'primeng/primeng';
import { IStrategyPermissions } from '../../models/IStrategyPermissions';
import { PlanCoordinate } from '../services/plan-coordinate';
import { ResourceService } from '../services/resource.service';

export class StepComponent<T> implements OnChanges {
  private static LOG_NG_ON_CHANGES = false;

  @ViewChild('confirmDeleteDialog') private confirmDeleteDialog: Dialog;
  @Output() itemDelete = new EventEmitter<T>();
  @Output() itemError = new EventEmitter<Error>();
  private itemToDelete: T;

  private _isVisible = false;
  @Input() permissions: IStrategyPermissions;
  @Input() set planCoordinate(planCoordinate: PlanCoordinate) {
    this.setPlanCoordinate(planCoordinate);
  }

  private _itemLabel = '';

  @Input() guideUrl: string;

  constructor(private readonly _planCoordinate: PlanCoordinate,
              readonly _resourceService: ResourceService) { }

  static logNgOnChanges(changes: SimpleChanges) {
    for (const c in changes) {
      if (StepComponent.LOG_NG_ON_CHANGES) {
        console.log(`${c}: current = ${JSON.stringify(changes[c].currentValue)}, previous = ${JSON.stringify(changes[c].previousValue)}`);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    StepComponent.logNgOnChanges(changes);
  }

  get planCoordinate() {
    return this._planCoordinate;
  }

  get isVisible() {
    return this._isVisible;
  }

  get itemLabel() {
    return this._itemLabel;
  }

  get isAddItemDisabled() {
    return !this.permissions.canEditBody;
  }

  get isEditItemDisabled() {
    return !this.permissions.canEditBody;
  }

  get isDeleteItemDisabled() {
    return !this.permissions.canEditBody;
  }

  get isReorderDisable() {
    return !this.permissions.canEditBody;
  }

  onClickDeleteItem(item: T, itemLabel = 'Item') {
    this.itemToDelete = item;
    this._itemLabel = itemLabel;
    this.confirmDialogVisible = true;
    if (!this.confirmDialogVisible) {
      this.deleteAccepted();
    }
  }

  onConfirmDeleteDialogAccept() {
    this.deleteAccepted();
  }

  onItemError(error: Error) {
    this.itemError.emit(error);
  }

  openGuide() {
    window.open(this.guideUrl, '_blank');
  }

  protected setPlanCoordinate(planCoordinate: PlanCoordinate) {
    if (this.isSetVisible(planCoordinate)) {
      this._isVisible = true;
      this.postSetVisible(this._isVisible);
    } else if (this.isVisible) {
      this._isVisible = false;
      this.postSetVisible(this._isVisible);
    }
  }

  protected isSetVisible(planCoordinate: PlanCoordinate): boolean {
    if (!this.planCoordinate) {
      console.error('isSetVisible', this.constructor.name, this.planCoordinate);
      return false;
    } else {
      return this.planCoordinate.isEqual(planCoordinate);
    }
  }

  protected postSetVisible(isVisible: boolean) { }

  private deleteAccepted() {
    this.confirmDialogVisible = false;
    this.itemDelete.emit(this.itemToDelete);
  }

  private get confirmDialogVisible() {
    return this.confirmDeleteDialog && this.confirmDeleteDialog.visible;
  }

  private set confirmDialogVisible(isVisible: boolean) {
    if (this.confirmDeleteDialog) {
      this.confirmDeleteDialog.visible = isVisible;
    }
  }
}
